export enum ImageCDNSizes {
  XSMALL = 16,
  SMALL = 32,
  MEDIUM = 48,
  DEFAULT = 64,
  LARGE = 128,
  XLARGE = 512,
  XXLARGE = 1024,
}
